import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientAllergyService = {
  getPatientAllergiesList(params){ return axiosRequest('GET', API_PATH.PATIENT_ALLERGY.LIST(params)) },
  getPatientAllergy(data){ return axiosRequest('POST', API_PATH.PATIENT_ALLERGY.INFO, data) },
  addPatientAllergy(data){ return axiosRequest('POST', API_PATH.PATIENT_ALLERGY.ADD, data) },
  deletePatientAllergy(data){ return axiosRequest('POST', API_PATH.PATIENT_ALLERGY.DELETE, data) },
}